// extracted by mini-css-extract-plugin
export default {"view":"SafetyAlertViewerView_view__uZ+0x"};